import React, { useState, useEffect } from 'react';
import Header from '../../componentes/header/header';
import JsonContainer from "../../componentes/containerJson/ContainerJson";
import ImagensArtigoCancerDeBoca from './ImagensJSON/ArtigoCancerDeBoca.json';
import ImagensDefesaVanessa from "./ImagensJSON/DefesaVanessa.json";
import Slides from '../../componentes/slides/slides';
import { Helmet } from "react-helmet";
import FinalComponent from "../../componentes/EndPage/Final";
import NoticiaArtigo from "./NoticiasJSON/NoticiaArtigoCancerDeBoca.json";
import NoticiaVanessa from "./NoticiasJSON/NoticiaDefesaVanessa.json";  
import translations from "./traducao.json"; 

function Noticias() {
    const [lang, setLang] = useState(localStorage.getItem("siteLanguage") || "pt"); 


    const handleLanguageChange = (newLang) => {
        setLang(newLang);
        localStorage.setItem("siteLanguage", newLang); 
        window.location.reload(); 
    };

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0];
        if (!localStorage.getItem("siteLanguage")) {
            localStorage.setItem("siteLanguage", browserLang);
        }
    }, []);

    const newsDataArtigo = NoticiaArtigo[lang] || NoticiaArtigo["pt"]; 
    const newsDataVanessa = NoticiaVanessa[lang] || NoticiaVanessa["pt"]; 
    const translation = translations[lang] || translations["pt"];

    return (
        <>
            <Helmet>
                <title>{translation?.news_title || "Notícias"} | SOBREVIDAS-ACS</title>
            </Helmet>
            <Header handleLanguageChange={handleLanguageChange} />   

            <h2 className="text-[30px] text-[#B040B1] mt-0 inline-block relative mb-[5%] font-black">
                {translation?.news_title || "Notícias"}
                <span className="absolute bottom-[-1px] left-[-55%] w-[200%] h-[45px] bg-gradient-to-r from-[rgba(106,13,173,0.4)] to-[rgba(255,102,178,0.4)] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] -z-20 rounded-[50px]"></span>
            </h2>
            
            <Slides data={ImagensArtigoCancerDeBoca} />

            <div className="text-left p-[2%] m-[5%_20%] border-l-[5px] border-l-[#6A0DAD] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] rounded-[2vh]">
                <JsonContainer data={newsDataArtigo} />
            </div>

            <Slides data={ImagensDefesaVanessa} />

            <div className="text-left p-[2%] m-[5%_20%] border-l-[5px] border-l-[#6A0DAD] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] rounded-[2vh]">
                <JsonContainer data={newsDataVanessa} />
            </div>

            <FinalComponent />
        </>
    );
}

export default Noticias;
